module.exports = __webpack_public_path__ + "static/media/inquiry_form.126ca2c6.svg";